<template>
  <div>
    <Head title="Schlafzimmer" />
    <section v-for="room in rooms" class="overflow-hidden text-gray-700 pt-4 pb-14">
      <silent-box :gallery="room['rooms']">
        <div class="flex flex-col items-center justify-center h-full w-full relative mb-4">
          <fade-image :src="room['image']" width="1220" height="500" class="rounded-lg shadow-md shadow-gray-500" />
          <div class="text-center absolute top-1/4 md:top-1/3 h-full w-full">
            <h2 class="text-white text-2xl font-semibold md:text-5xl text-shadow-lg">{{ room['name'] }}</h2>
            <div class="px-2 py-1 md:py-2 bg-blue-600 text-white md:text-2xl text-sm font-medium rounded hover:bg-blue-500 focus:outline-none focus:bg-blue-500">{{ room['description'] }}</div>
          </div>
        </div>
        <template v-slot:silentbox-item="{ silentboxItem }">
          <div class="w-full p-1 md:p-2 relative cursor-zoom-in">
            <fade-image :src="silentboxItem.src" width="600" height="800" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
            <div class="absolute right-4 bottom-3 md:right-6 md:bottom-5 text-white text-2xl">
              <font-awesome-icon icon="fa-solid fa-magnifying-glass-plus" />
            </div>
          </div>
        </template>
      </silent-box>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FadeImage from '@/Shared/FadeImage'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
    FadeImage,
  },
  layout: Layout,
  props: {
    rooms: Object,
  },
  data() {
    return {
      facilities: ['kostenfreies WLAN', 'TV', 'Gemeinschaftsraum', 'Kochmöglichkeit', 'Radio', 'Wasserkocher', 'Elektroherd mit Backofen', 'Kühlschrank', 'Kaffeemaschine', 'Mikrowelle', 'Spülmaschine', 'Kochutensilien', 'Zustellbett möglich', '3x Doppelbett', '1x Einzelbett', '3 Bäder', '2 Duschen', '1 Badewanne', '3 WC', 'Garten', 'Reinigungsmittel', 'Waschmaschine', 'PKW-Parkplatz', 'Grillmöglichkeit', 'Terrasse', 'Haustier auf Anfrage', 'Bettwäsche und Handtücher auf Anfrage'],
      lightboxList: [],
      lightboxIndex: 0,
    }
  },
  methods: {
    openLightbox: function (list, index) {
      this.lightboxList = list
      this.lightboxIndex = index
    },
  },
}
</script>
